import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import store from './Helpers/store';
import { Provider } from 'react-redux';
import AppRoutes from './AppRoutes';
import Root from './Helpers/Root';
import ToasterComponent from './Helpers/ToasterComponent';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Root>
          <ToasterComponent />
          <AppRoutes />
        </Root>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
